import * as CONST from 'Reducers/Mission/const'
import * as CAMPAIGN_CONST from 'Reducers/Campaigns/const'
import { CLEAR_ALL_FILTERS } from 'Reducers/Filter/const'

const initState = {
  filters: {
    pickup: { day: null, ambassador: null, client: null },
    masterSchedule: {
      week: null,
      city: null,
      location: null,
      keyword: null,
      status: null,
      loadedPage: 1,
      limit: 500,
    },
  },
  masterSchedules: {}, // List all the master schedules
  toPickupInCity: [],
  missionsByCityId: [],
  missionsList: [],
  missionsFilter: {},
  missionById: {},
  missionByIdGQL: {},
  errorMessage: '',
  missionsDayPeriodFilter: CONST.MISSIONS_DAY_PERIOD_FILTER_OPTIONS[0],
  missionsTypeFilter: CONST.MISSIONS_TYPE_FILTER_OPTIONS[0],
  missionsStatusFilter: CONST.MISSIONS_STATUS_FILTER_OPTIONS[0],
  rosterViewMissionsSortBy: {
    columnName: null,
    reverse: false,
  },
  // This is a hash map of missions with the key being the mission id and the
  // value being the mission data. It's used for the campaign metric results
  missions: {},
  missionsGQL: {},
}

export function missions(state = initState, action) {
  switch (action.type) {
    case CONST.FETCH_SCHEDULED_PICKUPS_SUCCESS:
      return {
        ...state,
        toPickupInCity: action.payload.missions,
      }

    case CONST.APPLY_FILTERS:
      return {
        ...state,
        filters: {
          ...state.filters,
          [action.filterType]: {
            ...state.filters[action.filterType],
            ...action.filters,
          },
        },
      }

    case CONST.GET_MISSIONS_BY_CITY_ID_SUCCESS:
      return {
        ...state,
        missionsByCityId: action.payload.missionsByCityId,
        missionsByCityIdCount: action.payload.missionsByCityIdCount,
      }

    case CONST.GET_MISSIONS_SUCCESS:
      return {
        ...state,
        missionsList: action.payload.missions,
      }

    case CONST.GET_CAMPAIGN_MISSIONS_SUCCESS:
      return {
        ...state,
        masterSchedules: {
          ...state.masterSchedules,
          [action.payload.campaignId]: action.payload.missions,
        },
      }

    case CONST.UPDATE_MISSION:
      const mission = action.payload.mission
      return {
        ...state,
        missions: {
          ...state.missions,
          [mission.id]: {
            ...state.missions[mission.id],
            ...mission,
          },
        },
      }

    case CONST.SET_MISSIONS_LIST_FILTER:
      return {
        ...state,
        missionsFilter: action.filters,
      }

    case CONST.SET_MISSIONS_TYPE_FILTER:
      return {
        ...state,
        missionsTypeFilter: action.missionsTypeFilter,
      }

    case CONST.SET_MISSIONS_DAY_PERIOD_FILTER:
      return {
        ...state,
        missionsDayPeriodFilter: action.missionsDayPeriodFilter,
      }

    case CONST.SET_MISSIONS_STATUS_FILTER:
      return {
        ...state,
        missionsStatusFilter: action.missionsStatusFilter,
      }

    case CONST.SET_ROSTER_VIEW_MISSIONS_SORT_BY:
      return {
        ...state,
        rosterViewMissionsSortBy: action.sortBy,
      }

    case CLEAR_ALL_FILTERS:
      return {
        ...state,
        filters: initState.filters,
        missionsFilter: initState.missionsFilter,
        missionsDayPeriodFilter: initState.missionsDayPeriodFilter,
        missionsTypeFilter: initState.missionsTypeFilter,
        missionsStatusFilter: initState.missionsStatusFilter,
      }
    case CAMPAIGN_CONST.GET_CAMPAIGN_RESULTS_SUCCESS:
      const processNewMissions = () => {
        var missions = {}
        var cityPlans = action.result.data.campaign.cityPlans.nodes
        cityPlans.forEach(cityPlan => {
          cityPlan.missions.edges.forEach(({ node }) => {
            missions[node.id] = Object.assign(
              {},
              // Use the existing data if it exists
              state.missions[node.id],
              {
                ...node,
                metricResultIds: node.metricResults.nodes.map(r => r.id),
                userId: node.user ? node.user.id : null,
                distributionCost: node.distributionCost,
                draftPayAdjustment: node.draftPayAdjustment,
                printingCostPerFlyer: node.printingCostPerFlyer / 100,
                cityPlanId: cityPlan.id,
                cityId: cityPlan.city.id,
                locationId: node.location ? node.location.id : null,
                campaignId: action.result.data.campaign.id,
                conversionIds: node.conversions.nodes.map(c => c.id),
              },
            )
          })
        })
        return missions
      }
      const newMissions = processNewMissions()
      return {
        ...state,
        missions: {
          ...state.missions,
          ...newMissions,
        },
      }
    case CONST.CREATE_MISSIONS_SUCCESS:
    case CONST.PUBLISH_MISSIONS_SUCCESS:
      return {
        ...state,
        missions: {
          ...state.missions,
          ...(() => {
            var subObject = {}
            action.result.forEach(mission => {
              subObject[mission.id] = {
                ...mission,
              }
            })
            return subObject
          })(),
        },
      }
    case CONST.DELETE_MISSIONS:
      var missionsClone = Object.assign({}, state.missions)
      action.payload.missions.forEach(({ id }) => delete missionsClone[id])
      return {
        ...state,
        missions: missionsClone,
      }
    case CONST.UNBOOK_MISSION_BY_ID_SUCCESS:
      const response = action.result.data.unbookMission.mission

      return {
        ...state,
        missions: {
          ...state.missions,
          [response.id]: {
            ...state.missions[response.id],
            status: response.status,
            userId: response.user ? response.user.id : null,
          },
        },
      }
    case CONST.GET_MISSION_BY_ID_GRAPH_QL_SUCCESS:
      const { mission: missionByIdGQL } = action.result.data

      return {
        ...state,
        missionsGQL: {
          ...state.missionsGQL,
          [missionByIdGQL.id]: missionByIdGQL,
        },
        missionByIdGQL: missionByIdGQL,
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/Reducers/Mission/reducer.js